export const disallowedFilenames = [
  'https://www.googletagmanager.com/gtm.js',
  'https://cdn.cookielaw.org/scripttemplates',
  'https://geolocation.onetrust.com/',
  'https://cdn.heapanalytics.com/js',
  'https://bite.australiarevival.com',
  'https://spider.australiarevival.com/',
  'https://tracking.g2crowd.com/',
  'https://bat.bing.com/bat.js',
  'https://ara.paa-reporting-advertising.amazon',
  
  'https://static.klaviyo.com/onsite',
  '/onsite/js/',

  'https://js.qualified.com',
  'https://assets.qualified.com',
  'https://player.vimeo.com',
  'https://f.vimeocdn.com',
  'https://cdn.pdst.fm',
  'https://www.redditstatic.com/',
  
  'https://ct.capterra.com/',
  'https://client-registry.mutinycdn.com/',
  'https://extend.vimeocdn.com/',
  'https://d41.co/',

  'https://tracking.intentsify.io',
  'https://js.adsrvr.org/',
  'https://insight.adsrvr.org/',

  'https://js.hs-scripts.com',
  'https://js.hs-analytics.net',
  'https://js.hs-banner.com',
  'https://track.hubspot.com',
];
